import React, { useEffect, useRef, useState } from "react";
import { CtaButton } from "./CtaButton";
const HIDE_NEAR = ["oferta", "cierre"];
const SCROLL_THRESHOLD = 650;
export function MobileCtaBar() {
  const [visible, setVisible] = useState(false);
  const overlapping = useRef(new Set<string>());
  const pastThreshold = useRef(false);
  useEffect(() => {
    const sync = () => setVisible(pastThreshold.current && overlapping.current.size === 0);

    // Section overlap via IntersectionObserver (no layout reads during scroll).
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) overlapping.current.add(entry.target.id);else overlapping.current.delete(entry.target.id);
      });
      sync();
    });
    HIDE_NEAR.forEach(id => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    // Scroll threshold: only reads scrollY, throttled to one check per frame.
    let frame = 0;
    const onScroll = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const next = window.scrollY > SCROLL_THRESHOLD;
        if (next !== pastThreshold.current) {
          pastThreshold.current = next;
          sync();
        }
      });
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", onScroll);
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);
  return <div aria-hidden={!visible} {...!visible ? {
    inert: ""
  } : {}} className={`fixed inset-x-0 bottom-0 z-40 border-t border-line bg-white/95 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur transition-[transform,opacity,visibility] duration-[220ms] ease-out motion-reduce:transition-opacity md:hidden ${visible ? "visible translate-y-0 opacity-100" : "invisible translate-y-full opacity-0 motion-reduce:translate-y-0"}`} data-id="element-155" data-mp="2rmiwhzxnqup0">
      <div className="flex items-center justify-between gap-3" data-id="element-156" data-mp="zvgha7d5h19l">
        <p className="min-w-0 text-xs font-semibold leading-tight text-ink" data-id="element-157" data-mp="14oi18ts7rr01">
          Ebook + 8 bonos
          <span className="block font-normal text-muted" data-id="element-158" data-mp="qx4obyot9rdz">+ kit en el celular</span>
        </p>
        <CtaButton size="md" data-id="element-159" data-mp="vw7pv95l1fh7">Quiero mi kit</CtaButton>
      </div>
    </div>;
}